import { EuiChipTooltip } from '../../eui-chip';

export class EuiAutoCompleteItem {
    id: string | number;
    euiInternalId: string;
    label: string;
    typeClass: ('primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger' );
    sizeClass: ('euiSizeS' | 'euiSizeM' | 'euiSizeL' | 'euiSizeXL' | 'euiSize2XL');
    iconClass: string;
    isRemovable: boolean;
    isOutline: boolean;
    isRounded: boolean;
    dragAndDropSource: string;
    tooltip?: EuiChipTooltip;
    metadata?: any;

    constructor(values: Object = {}) {
        Object.assign(this, values);
    }
}
